import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { PasswordRecoverySteps, type PasswordRecoveryState } from "./types";

const initialState: PasswordRecoveryState = {
  mobilePhone: null,
  step: PasswordRecoverySteps.PHONE_NUMBER_STEP,
  resendCoolDown: 0,
};

export const passwordRecoverySlice = createSlice({
  name: "recovery",
  initialState,
  reducers: {
    setMobilePhone: (state, action: PayloadAction<string>) => {
      state.mobilePhone = action.payload;
    },
    clearMobilePhone: (state) => {
      state.mobilePhone = null;
    },
    setStep: (state, action: PayloadAction<PasswordRecoverySteps>) => {
      state.step = action.payload;
    },
    resetSteps: (state) => {
      state.step = PasswordRecoverySteps.PHONE_NUMBER_STEP;
    },
    setResendCoolDown: (state, action: PayloadAction<number>) => {
      state.resendCoolDown = action.payload;
    },
    clearResendCoolDown: (state) => {
      state.resendCoolDown = 0;
    },
    resetState: (state) => {
      Object.assign(state, initialState);
    },
  },
  selectors: {
    selectMobilePhone: (state) => state.mobilePhone,
    selectStep: (state) => state.step,
    selectResendCoolDown: (state) => state.resendCoolDown,
  },
});

export const startCoolDownTimer = createAsyncThunk<
  void,
  number,
  { state: { recovery: PasswordRecoveryState } }
>("recovery/startTimer", async (duration, { dispatch, getState }) => {
  dispatch(passwordRecoveryActions.setResendCoolDown(duration));
  const tick = () => {
    setTimeout(() => {
      const currentCoolDown = getState().recovery.resendCoolDown;
      if (currentCoolDown > 0) {
        dispatch(passwordRecoveryActions.setResendCoolDown(currentCoolDown - 1));
        tick();
      }
    }, 1000);
  };
  tick();
});

export const { actions: passwordRecoveryActions, selectors: passwordRecoverySelectors } =
  passwordRecoverySlice;
